import { addRpcUrlOverrideToChain, PrivyClientConfig, WalletListEntry } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';
import { Chain } from 'viem';

import { SUPPORTED_CHAINS } from '@/constants/chain';
import { JWT_PROTECTED_JSON_RPC_HTTP_URL_BY_CHAIN_ID } from '@/constants/rpc';

import { routes } from './routes';

export const PRIVY_ID = process.env.NEXT_PUBLIC_PRIVY_ID as string;

export const PRIVY_CLIENT_ID = process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID as string;

const walletConnectCloudProjectId = process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID;

// configure wallet connectors
export const getWalletList = (isMobile: boolean): WalletListEntry[] => {
  // TODO: revisit the `walletList` flag, as we believe this value causes a refresh bug with Privy.
  // See: https://0xproject.slack.com/archives/C07552A6Z7W/p1740084312980349

  const walletList: WalletListEntry[] = [
    // order is display order in UI
    'coinbase_wallet',
    'metamask',
    ...(!isMobile ? ['phantom' as WalletListEntry] : []),
    'rainbow',
    'rabby_wallet',
    ...(!isMobile ? ['backpack' as WalletListEntry] : []),
    'zerion',
    'detected_ethereum_wallets',
    'detected_solana_wallets',
    'wallet_connect',
    'wallet_connect_qr',
  ] as WalletListEntry[];

  return walletList;
};

const solanaConnectors = toSolanaWalletConnectors({
  // By default, shouldAutoConnect is enabled
  shouldAutoConnect: true,
});

export const config: PrivyClientConfig = {
  // Customize Privy's appearance in your app
  appearance: {
    theme: 'light',
    accentColor: '#00B96D',
    logo: 'https://matcha.xyz/apple-touch-icon.png',
    walletChainType: 'ethereum-and-solana',
    showWalletLoginFirst: true,
  },
  externalWallets: { solana: { connectors: solanaConnectors } },
  // Create embedded wallets for users who don't have a wallet
  // Uncomment when enabling embedded wallets
  // embeddedWallets: {
  //   createOnLogin: 'users-without-wallets',
  //   requireUserPasswordOnCreate: true,
  //   showWalletUIs: false,
  // },
  /** All legal configuration */
  legal: {
    termsAndConditionsUrl: routes.TERMS,
    privacyPolicyUrl: routes.PRIVACY,
  },
  loginMethods: ['wallet'],
  supportedChains: SUPPORTED_CHAINS.map((chain: Chain) =>
    addRpcUrlOverrideToChain(chain, JWT_PROTECTED_JSON_RPC_HTTP_URL_BY_CHAIN_ID[chain.id]),
  ),
  walletConnectCloudProjectId,
};

/** Convert EVM Caip-2 chainId format to number
 *
 * @remarks
 *
 * This function is used to extract the chainId number from the privy chainId format "eip155:1285"
 * https://docs.privy.io/reference/sdk/server-auth/type-aliases/EvmCaip2ChainId
 *
 * @param chainId - privy chainId format
 */
export const getChainIdNumberFromCaip2ChainId = (chainId: string): number =>
  parseInt(chainId.split(':')[1], 10);
